import React, { useMemo } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import {
  STREAMING_UGC_PLATFORMS,
  StreamingUgcPlatform,
  StreamingUgcPlatformRow,
} from 'fym-shared/src/music24/streamingSections';
import { TypedMemo } from '../../../../common/types';
import { shortVideoMessages as messages } from '../../shortVideoMessages';
import { UGC_PLATFORM_LOOKS } from './ugcPlatforms';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import shared from '../../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the period sections; each part uses its own slice of it */
import styles from '../../StreamingPeriod.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface UgcPlatformRowProps {
  /** The platforms the source gives. Empty: every platform of the contract. */
  platforms: readonly StreamingUgcPlatformRow[];
  picked: StreamingUgcPlatform | null;
  onPick: (platform: StreamingUgcPlatform | undefined) => void;
}

/** The platform row (design streaming-sections c1): "All platforms" and one option per platform. */
const UgcPlatformRowComponent: React.FC<UgcPlatformRowProps> = ({ platforms, picked, onPick }) => {
  const intl = useIntl();
  const list = useMemo(
    () => (platforms.length > 0 ? platforms.map((row) => row.platform) : [...STREAMING_UGC_PLATFORMS]),
    [platforms]
  );
  return (
    <div className={styles.switch} role="group" aria-label={intl.formatMessage(messages.platformLabel)}>
      <span className={styles.switchKey}>{intl.formatMessage(messages.platformLabel)}</span>
      <button
        type="button"
        aria-pressed={picked === null}
        className={clsx(styles.switchOption, picked === null && styles.switchOn)}
        onClick={() => onPick(undefined)}
      >
        {intl.formatMessage(messages.allPlatforms)}
      </button>
      {list.map((platform) => (
        <button
          key={platform}
          type="button"
          aria-pressed={picked === platform}
          className={clsx(styles.switchOption, picked === platform && styles.switchOn)}
          onClick={() => onPick(platform)}
        >
          <span className={shared.cc}>{UGC_PLATFORM_LOOKS[platform].code}</span>
          {UGC_PLATFORM_LOOKS[platform].shortName}
        </button>
      ))}
    </div>
  );
};

export const UgcPlatformRow = TypedMemo(UgcPlatformRowComponent);
